export const BASE_URL = 'https://marinesamraj.com';
export const DEFAULT_OG_IMAGE = `${BASE_URL}/assets/icons/icon-512x512.png`;
